export const primary = {
  50: '#000001',
  100: '#000105',
  150: '#00020f',
  200: '#00051b',
  250: '#000a28',
  300: '#001036',
  350: '#001645',
  400: '#001c54',
  450: '#002363',
  500: '#002a73',
  550: '#1a3f82',
  600: '#325490',
  650: '#49699e',
  700: '#617dad',
  750: '#7a92bb',
  800: '#93a7c8',
  850: '#adbdd6',
  900: '#c8d3e4',
  950: '#e3e9f2',
  975: '#f2f9f8',
  990: '#fafcfc',
} as const;